import type { Transition } from 'framer-motion';

/**
 * NovelFlow - 共通「もっちり・心地よい」スプリングアニメーション・プリセット
 */

// 1. もっちりポップ: ボタンタップ、アイコン押し込み、ダイアログ・カードの出現
export const SPRING_BOUNCY: Transition = {
  type: 'spring',
  stiffness: 420,
  damping: 18,
  mass: 0.8,
};

// 2. スーッと心地よい: ボトムシートのドラッグ復元・開閉、ヘッダー/フッターの表示トグル
export const SPRING_SMOOTH: Transition = {
  type: 'spring',
  stiffness: 320,
  damping: 28,
  mass: 1.0,
};

// 3. クイック＆スナッピー: スイッチ切り替え、タブ選択、ピルインジケーターの移動
export const SPRING_SNAPPY: Transition = {
  type: 'spring',
  stiffness: 480,
  damping: 24,
  mass: 0.6,
};

// 4. ゆったりエレガント: 大型ダイアログやフルスクリーン切り替え
export const SPRING_ELEGANT: Transition = {
  type: 'spring',
  stiffness: 260,
  damping: 25,
  mass: 1.1,
};

// タッチ（押し込み）スケール定数
export const TAP_SCALE_SMALL = { scale: 0.92 };
export const TAP_SCALE_MEDIUM = { scale: 0.95 };
export const TAP_SCALE_LARGE = { scale: 0.98 };

// ホバー浮き上がり定数
export const HOVER_LIFT_SMALL = { y: -2 };
export const HOVER_LIFT_MEDIUM = { y: -4 };
